import "./CreditreformPanel.css";
import creditreformLogo from "../../../assets/creditreform-logo.svg";

function CreditreformPanel() {
  return (
    <section className="creditreform-panel-container">
      <div className="creditreform-panel-inner hover-lift">
        <header className="creditreform-panel-top">
          <span className="creditreform-badge">Vertrauens- & Bonitätscheck</span>

          <div className="creditreform-brand">
            <img
              className="creditreform-panel-logo"
              src={creditreformLogo}
              alt="Creditreform"
              loading="lazy"
            />
          </div>

          <div className="creditreform-top-copy">
            <h2>Bonitätsprüfung für sichere Geschäftsbeziehungen</h2>
            <p className="creditreform-subline">
              Für planbare Abläufe und fair kalkulierte Leistungen prüfen wir neue
              Geschäftspartner vor Auftragsannahme.
            </p>
          </div>
        </header>

        <div className="creditreform-panel-grid">
          <div className="creditreform-panel-main">
            <p>
              So minimieren wir Zahlungsausfall-Risiken und schaffen eine transparente
              Basis für eine langfristige Zusammenarbeit – besonders bei größeren
              Auftragsvolumen im B2B.
            </p>

            <ul className="creditreform-panel-bullets">
              <li>Prüfung von Bonität & Risiko vor Projektstart</li>
              <li>Mehr Sicherheit bei größeren Auftragsvolumen</li>
              <li>Professionelle Standards in der Zusammenarbeit</li>
            </ul>

            <p className="creditreform-panel-footnote">
              Hinweis: Die Prüfung erfolgt nur im Rahmen der gesetzlichen Vorgaben und
              ausschließlich für geschäftliche Zwecke.
            </p>
          </div>

          <aside className="creditreform-panel-aside">
            <div className="creditreform-aside-card">
              <h3>Warum wir das machen</h3>
              <div className="creditreform-metrics">
                <div className="creditreform-metric">
                  <span className="creditreform-metric-label">Planbarkeit</span>
                  <span className="creditreform-metric-value">für Teams & Termine</span>
                </div>
                <div className="creditreform-metric">
                  <span className="creditreform-metric-label">Sicherheit</span>
                  <span className="creditreform-metric-value">bei größeren Budgets</span>
                </div>
                <div className="creditreform-metric">
                  <span className="creditreform-metric-label">Transparenz</span>
                  <span className="creditreform-metric-value">klare B2B-Prozesse</span>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default CreditreformPanel;
